/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IngestionLogsJsonZipIngestResponseDto
 */
export interface IngestionLogsJsonZipIngestResponseDto {
    /**
     * Original uploaded archive name
     * @type {string}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    archiveName: string;
    /**
     * Configured batch size used to compute processing chunks
     * @type {number}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    batchSize: number;
    /**
     * Number of json or jsonl files parsed from the archive
     * @type {number}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    jsonlFileCount: number;
    /**
     * Number of non-json and non-jsonl entries skipped
     * @type {number}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    skippedEntryCount: number;
    /**
     * Total number of JSON records extracted
     * @type {number}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    recordCount: number;
    /**
     * Total number of processing batches implied by the record count
     * @type {number}
     * @memberof IngestionLogsJsonZipIngestResponseDto
     */
    batchCount: number;
}

/**
 * Check if a given object implements the IngestionLogsJsonZipIngestResponseDto interface.
 */
export function instanceOfIngestionLogsJsonZipIngestResponseDto(value: object): value is IngestionLogsJsonZipIngestResponseDto {
    if (!('archiveName' in value) || value['archiveName'] === undefined) return false;
    if (!('batchSize' in value) || value['batchSize'] === undefined) return false;
    if (!('jsonlFileCount' in value) || value['jsonlFileCount'] === undefined) return false;
    if (!('skippedEntryCount' in value) || value['skippedEntryCount'] === undefined) return false;
    if (!('recordCount' in value) || value['recordCount'] === undefined) return false;
    if (!('batchCount' in value) || value['batchCount'] === undefined) return false;
    return true;
}

export function IngestionLogsJsonZipIngestResponseDtoFromJSON(json: any): IngestionLogsJsonZipIngestResponseDto {
    return IngestionLogsJsonZipIngestResponseDtoFromJSONTyped(json, false);
}

export function IngestionLogsJsonZipIngestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestionLogsJsonZipIngestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'archiveName': json['archiveName'],
        'batchSize': json['batchSize'],
        'jsonlFileCount': json['jsonlFileCount'],
        'skippedEntryCount': json['skippedEntryCount'],
        'recordCount': json['recordCount'],
        'batchCount': json['batchCount'],
    };
}

export function IngestionLogsJsonZipIngestResponseDtoToJSON(json: any): IngestionLogsJsonZipIngestResponseDto {
    return IngestionLogsJsonZipIngestResponseDtoToJSONTyped(json, false);
}

export function IngestionLogsJsonZipIngestResponseDtoToJSONTyped(value?: IngestionLogsJsonZipIngestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'archiveName': value['archiveName'],
        'batchSize': value['batchSize'],
        'jsonlFileCount': value['jsonlFileCount'],
        'skippedEntryCount': value['skippedEntryCount'],
        'recordCount': value['recordCount'],
        'batchCount': value['batchCount'],
    };
}

